// Bloques personalizados
import initScrollSlider from "./blocks/scroll-slider";
import initTabsVerticalImage from "./blocks/tabs-vertical-image";
import initFormPopup from "./blocks/form-popup";
import "@iconify/iconify";
console.log(`
\ _   _      _ _         _____ _
| | | | ___| | | ___   |_   _| |__   ___ _ __ ___
| |_| |/ _ \\ | |/ _ \\    | | | '_ \\ / _ \\ '__/ _ \\
|  _  |  __/ | | (_) |   | | | | | |  __/ | |  __/
|_| |_|\\___|_|_|\\___/    |_| |_| |_|\\___|_|  \\___|
`);

/* +-----------------------------------------+
|           GLOBALS AREA             		 |
+-----------------------------------------+ */

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { ScrollSmoother } from "gsap/ScrollSmoother";

gsap.registerPlugin(ScrollTrigger);
// gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

window.DEBUG = false;
window.MNK = !ScrollTrigger.isTouch; 
window.TOUCH = !!ScrollTrigger.isTouch;

/* +-----------------------------------------+
|           IMPORTS AREA             		 |
+-----------------------------------------+ */

// Swiper
import initSwipers from "./swiper/initSwipers"; 

// CSS
import "../assets/icons/scss/icons.scss";
import "../styles/bootstrap/bootstrap.scss"; 
import "../styles/frontend.scss";

// Bootstrap
import "bootstrap/js/dist/collapse";
import "bootstrap/js/dist/dropdown";
import "bootstrap/js/dist/modal";
import "bootstrap/js/dist/tab";

// GSAP
import initGsap from "./gsap/initGsap";
import initGsapTriggers from "./gsap/utilities/initGsapTriggers";
import initGsapLenis from "./gsap/utilities/initGsapLenis";
import gsapScrollTo from "./gsap/utilities/gsapScrollTo";

// Utilities
import initLoader from "./utilities/initLoader";
import initHeaderLogoSwap from "./utilities/initHeaderLogoSwap";
import getDimensions from "./utilities/getDimensions";
import initMouseFollower from "./utilities/initMouseFollower";
import initGlightbox from "./utilities/initGlightbox";
import initReadSmore from "./utilities/initReadSmore";
import kobleQuickView from "./utilities/kobleQuickView";
import initMaps from "./utilities/initMaps";
import appendToBody from "./utilities/appendToBody";
import togglePairedCheckboxes from "./utilities/togglePairedCheckboxes";
import initToastify from "./utilities/initToastify";
import initShare from "./utilities/initShare";
import currencySwitcher from "./utilities/currencySwitcher";
import initCleave from "./utilities/initCleave";
import openModalByUrl from "./utilities/openModalByUrl";
import initDrawer from "./utilities/initDrawer";
import getStickyElements from "./utilities/getStickyElements";
import initBlogAjax from "./utilities/initBlogAjax";
import initCheckboxMixed from "./utilities/initCheckboxMixed";
import initToggle from "./blocks/initToggle";
import initYoyoLinkArrow from "./utilities/initYoyoLinkArrow";

/* +-----------------------------------------+
|           EVENTS AREA             		 |
+-----------------------------------------+ */

// DOC Ready
document.addEventListener(
    "DOMContentLoaded",
    () => {
        getDimensions("#app-header", "height");
        // getDimensions("#app-topbar", "height");
        getDimensions("#app-navbar", "height");

        initGsapLenis();

        initReadSmore();

        initScrollSlider();
        initTabsVerticalImage();
        initFormPopup();
        initSwipers();
        initToggle();
        initGlightbox();
        kobleQuickView();
        initMaps();
        togglePairedCheckboxes();
        initToastify();
        initShare();
        currencySwitcher();
        initCleave();
        openModalByUrl();
        initDrawer();
        initBlogAjax();
        initCheckboxMixed();
        initGsap();
        initGsapTriggers();
        initFadeInOnView();
        initHeaderLogoSwap();
    },
    { once: true }
);


/**
 * Fade-in helper: animate elements when they enter the viewport.
 * Use either class `.js-fade-in` or attribute `data-gsap-fade="true"`.
 * Optional data attributes (all values are strings):
 *  - data-duration (ms) default 560
 *  - data-delay (ms) default 0
 *  - data-start default 'top bottom'
 *  - data-y (px) translateY start distance, default 12
 *  - data-x (px) translateX start distance, default 0
 *  - data-once present -> plays only once
 *  - data-ease optional easing name
 *  - data-debug present -> show ScrollTrigger markers
 */
function initFadeInOnView() {
    if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") return;

    const nodes = Array.from(document.querySelectorAll('.js-fade-in, [data-gsap-fade]'));
    if (!nodes.length) return;

    nodes.forEach((el) => {
        const dataset = el.dataset || {};
        const duration = (dataset.duration ? Number(dataset.duration) : 560) / 1000;
        const delay = (dataset.delay ? Number(dataset.delay) : 0) / 1000;
        const y = dataset.y ? Number(dataset.y) : 12;
        const x = dataset.x ? Number(dataset.x) : 0;
        const start = dataset.start || 'top bottom';
        const ease = dataset.ease || 'power3.out';
        const once = 'once' in dataset || 'gsapFadeOnce' in dataset || dataset.once === 'true';
        const debug = 'debug' in dataset || dataset.gsapFadeDebug !== undefined;

        // initial state
        gsap.set(el, { autoAlpha: 0, y, x, willChange: 'transform, opacity' });

        const config = {
            trigger: el,
            start: start,
            toggleActions: once ? 'play none none none' : 'play none none reset',
            once: once,
            markers: debug,
        };

        gsap.to(el, {
            autoAlpha: 1,
            y: 0,
            x: 0,
            duration,
            delay,
            ease,
            scrollTrigger: config,
        });
    });
}

// WINDOW Ready
window.addEventListener(
    "load",
    () => {

        // requestAnimationFrame(() => {
        //     ScrollSmoother.refresh(true);
        //     ScrollTrigger.refresh(true);
        //     console.log("refresh");
        // });

        // setTimeout(() => {
        //     ScrollSmoother.refresh(true);
        //     ScrollTrigger.refresh(true);
        //     console.log("refresh");
        // }, 3000);

        getStickyElements();
        appendToBody(".modal");

        // if (MNK) initMouseFollower();

        initLoader();
        initYoyoLinkArrow();

        const hash = window.location.hash;
        if (hash) gsapScrollTo(hash);
    },
    { once: true }
);

// WS Form
(function ($) {
    $(document).on("wsf-rendered", () => {
        getDimensions(".iti__flag-container", "width");
        getDimensions("input.wsf-field", "height");
    });

    $(document).on(
        "wsf-validate-after",
        function (
            event,
            form_object,
            form_id,
            instance_id,
            form_el,
            form_canvas_el
        ) {
            const transitionSpeed = parseFloat(
                getComputedStyle(form_el[0])
                    .getPropertyValue("--wsf-form-transition-speed")
                    .replace("ms", "")
                    .trim()
            );

            setTimeout(getStickyElements, transitionSpeed);
        }
    );

    // Google Ads Conversion
    $(document).on("wsf-submit-success", () => {
        console.log("WS Form submitted successfully");
        if (typeof gtag_report_conversion === "function") {
            gtag_report_conversion();
        }
    });
})(jQuery);

